import { useMutation, useQueryClient } from 'react-query';
import { User } from '~types/api/user';
import { BASE_API_URL } from '@env';

import { useUserStore } from '~providers/userStore/zustand';
export function useUpdateUserPostCode() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (postCode: string) => {
      const userId = useUserStore.getState().user?.uid;

      const token = useUserStore.getState().token;

      const response = await fetch(`${BASE_API_URL}users/${userId}/postal-code?postal_code=${postCode}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to update user');
      }

      return response.json() as Promise<User>;
    },
    { onSuccess: () => queryClient.refetchQueries(['userAccount']) },
  );

  return mutation;
}
